<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list!=null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Add Roll Number
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" @click="putnull()" outlined
                        @change="getDiv" persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined @click="putnull()" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col sm="2" v-if="div_list!=null">
                    <v-btn class="mt-6 button" @click="addRollNo">Proceed</v-btn>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="learner !='' && learner != null">
                <v-btn class="mt-6 button" :loading="loader" @click="resetRollNo(learner[0])">Reset Roll No</v-btn>
            </v-row>
            <v-row dense justify="center" v-if="learner !='' && learner != null">
                <span style="color:red">Note: Default Roll No Will Be Set To 0</span>
            </v-row>



            <span v-if="learner !='' && learner != null">
                <v-row class="p-0 m-0">
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                        <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table"
                            single-line hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-data-table dense :headers="headers1" :items="learner[0]" :search="search" class="elevation-1">

                    <template v-slot:[`item.rollnotobeassigned`]="{ item }">
                        <v-text-field color="#0f2027" class="mt-2" v-model="item.rollno_to_be_assigned"
                            label="Add Roll No." outlined dense rounded hint="For example :: 1,2,3"></v-text-field>
                    </template>
                    <template v-slot:[`item.addrollno`]="{ item }">
                        <v-btn class="mt-6 button" small :loading="loader" @click="addsingleRollNo(item)">Save</v-btn>
                    </template>
                </v-data-table>
                <v-row dense justify="center" v-if="div_list!=null">
                    <v-btn class="mt-6 button" :loading="loader" @click="approveRollNo(learner[0])">Approve</v-btn>
                </v-row>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                // extraBreadcrumbItems: [
           

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                overlay: false,
                loader:false,
                learner:[],
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    // {
                    //     text: "Full Name",
                    //     align: "center",
                    //     sortable: false,
                    //     value: "full_name",
                    // },
                    {
                        text: "Gender",
                        align: "center",
                        sortable: false,
                        value: "gender",
                    },
                    {
                        text: "First Name",
                        align: "center",
                        sortable: false,
                        value: "fname",
                    },
                    {
                        text: "Middle Name",
                        align: "center",
                        sortable: false,
                        value: "mname",
                    },
                    {
                        text: "Last Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "PRN No.",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Old Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "New Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollnotobeassigned",
                    }, 
                    {
                        text: "Save Roll No",
                        align: "center",
                        sortable: false,
                        value: "addrollno",
                    }, 
                ],
            };
        },
        methods: {
            putnull(){
                this.learner = null
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = null;
                this.div = null;
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            resetRollNo() {
                  if (!confirm("Are You Sure You Want To Reset Roll Numbers?"))
                 return;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division: this.div.div_off_id,
                };
                this.loader=true
                axios
                    .post("/Admission/resetRollNo", data)
                    .then((res) => {
                        this.showSnackbar("green", "Saved Successfully..!!!"); // show snackbar on success
                        this.addRollNo();
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        // //close loader
                         this.addRollNo();
                         this.loader=false
                    });
            },
            addRollNo() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division: this.div.div_off_id,
                };
                axios
                    .post("/Admission/addRollNo", data)
                    .then((res) => {
                        this.learner = res.data.learner
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        // //close loader
                        
                    });
            },
            addsingleRollNo(item){
                 for(var i = 0;i < this.learner[0].length;i++){
                    if(this.learner[0][i].rollno == item.rollno_to_be_assigned){
                      //  alert("in if")
                        this.showSnackbar("#b71c1c", "Roll no. should be unique");
                        return
                    }
                }
                const data = {
                    learner: item,
                };
                axios
                    .post("/Admission/addSingleRollNo", data)
                    .then((res) => {
                            if(res.data.flag == "YES"){
                                this.loader = false
                                this.showSnackbar("#4caf50", "New roll no. added successfully");
                                this.addRollNo();
                            }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        // //close loader
                        this.loader = false
                    });
            },
            approveRollNo(learner){
                for(var i = 0;i<learner.length;i++){
                    for(var j = i+1;j<learner.length;j++){
                        if(learner[i].rollno_to_be_assigned == learner[j].rollno_to_be_assigned){
                            this.showSnackbar("#b71c1c", "Roll no. should be unique");
                            return
                        }
                    }
                }
                this.loader = true
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    learner: learner,
                };
                axios
                    .post("/Admission/approveRollNo", data)
                    .then((res) => {
                            if(res.data.flag == "YES"){
                                this.loader = false
                                this.showSnackbar("#4caf50", "New roll no. added successfully");
                                this.addRollNo();
                            }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        // //close loader
                        this.loader = false
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                //this.uid = localStorage.getItem("EPS-uid")
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
